import { pathOr } from 'ramda'


/**
 * Get selected room options IDs
 * @param options
 * @returns {*}
 * @constructor
 */
export const GetOptionsIDs = options => options
  .filter(option => option.active || (option.checkbox && option.checkbox.checked))
  .map(option => option.id)

/**
 * Create the object for an API call
 * @param roomId
 * @param offerId
 * @param options
 * @returns {{roomCode: string, offerCode: string, option: *}}
 * @constructor
 */
export const ShoppingCartObject = (roomId, offerId, options) => ({
  roomCode: `${roomId}`,
  offerCode: `${offerId}`,
  option: options,
})

/**
 * Selector for selected room offer and options
 * @param state
 * @returns {Object}
 */
export default (state) => {
  /**
   *
   * @type {String}
   */
  const roomRate = pathOr(false, ['main', 'selectedRate'], state)
  if (!roomRate) {
    return false
  }

  const [roomId, offerId] = roomRate.split('|')

  if (!roomId || !offerId) {
    return false
  }

  /**
   * Available Room options
   * @type {Array}
   */
  const roomOptions = pathOr([], ['main', 'roomOptions'], state)

  /**
   *
   * To use action without options
   */

  /* if (roomOptions.length < 1) {
    return false
  } */


  const activeOptions = GetOptionsIDs(roomOptions)

  /**
   *
   * To use action without options
   */

  /* if (activeOptions.length < 1) {
    return false
  } */

  return ShoppingCartObject(roomId, offerId, activeOptions)
}
